import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/login/close.png';
import _imports_1 from '@/assets/images/logo.png';
import _imports_2 from '@/assets/images/login/select.png';
const _hoisted_1 = { class: "login_phone flexColumn-alc" };
const _hoisted_2 = { class: "lp_form flexColumn-alc flex-jcc flex1" };
const _hoisted_3 = {
    class: "flexColumn",
    style: { "width": "100%" }
};
const _hoisted_4 = { class: "flexColumn lpf_avatar" };
const _hoisted_5 = { class: "flexRow-alc" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
    key: 0,
    src: _imports_2,
    class: "lpfa_select"
};
const _hoisted_9 = { class: "lpf_btn" };
import { reactive, ref, onMounted } from 'vue';
import request from '@/api/request';
import feedback from '@/utils/feedback';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'login_info',
    emits: ['close'],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        const store = useStore();
        onMounted(() => {
            var _a;
            if ((_a = store.state.userInfo) === null || _a === void 0 ? void 0 : _a.id) {
                Object.keys(form).forEach(key => {
                    if (key in store.state.userInfo) {
                        form[key] = store.state.userInfo[key] || '';
                    }
                });
                if (!form.avatar)
                    form.avatar = avatar_list[0];
            }
        });
        const loading = ref(false);
        const avatar_list = reactive([
            "https://ppt-1320245968.cos.ap-guangzhou.myqcloud.com/mouse/20241217/202412171734431989267.png",
            "https://ppt-1320245968.cos.ap-guangzhou.myqcloud.com/mouse/20241217/202412171734431989270.png",
        ]);
        const form = reactive({
            nickname: '',
            avatar: avatar_list[0],
            sex: 1
        });
        const editUser = async () => {
            if (!form.nickname)
                return feedback.msgWarning('请填写昵称');
            loading.value = true;
            let params = JSON.parse(JSON.stringify(form));
            console.log(params);
            let res;
            try {
                res = await request.put('/app-api/member/user/update', params);
            }
            catch (error) {
            }
            loading.value = false;
            if ((res === null || res === void 0 ? void 0 : res.code) !== 0)
                return;
            store.dispatch('getUserInfo');
            feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
            emits('close');
        };
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "lp_close clickable",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                }, _cache[2] || (_cache[2] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                ])),
                _cache[6] || (_cache[6] = _createElementVNode("aside", { class: "flexColumn-alc flex-jcc lp_title" }, [
                    _createElementVNode("img", { src: _imports_1 }),
                    _createElementVNode("span", { class: "ft20 ftBold" }, "登录成功")
                ], -1)),
                _createElementVNode("aside", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "lpf_name" }, "昵称", -1)),
                        _createVNode(_component_el_input, {
                            modelValue: form.nickname,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.nickname) = $event)),
                            style: { "width": "100%" },
                            placeholder: "请填写昵称",
                            maxlength: "20"
                        }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "lpf_name" }, "头像", -1)),
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(avatar_list, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "lpfa_box clickable",
                                    key: index,
                                    onClick: ($event) => (form.avatar = item)
                                }, [
                                    _createElementVNode("img", {
                                        src: item,
                                        class: "lpfa_img"
                                    }, null, 8, _hoisted_7),
                                    (item === form.avatar)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                                        : _createCommentVNode("", true)
                                ], 8, _hoisted_6));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_button, {
                            type: "primary",
                            disabled: !form.nickname,
                            loading: loading.value,
                            onClick: editUser
                        }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createTextVNode("确认")
                            ])),
                            _: 1
                        }, 8, ["disabled", "loading"])
                    ])
                ])
            ]));
        };
    }
});
